import actions from "../actions";
import * as Constants from "../util/StorageConstants";

const initialState = {
    currentToken: null,
    currentAdminPage: 'Login',
    loginStatus: null,
    username: null,
    fullName: null,
    currentInstance: null,
    currentCategory: null,
    currentEntries: [],
    filteredEntries: [],
    playersPageOrder: 'asc',
    playersPageOrderBy: null,
    playersPagePage: 0,
    playersPageRowsPerPage: 10,
    playersPageEntryMap: {},
    playersPageSearchTerm: '',
    deleteEntryError: null,
};


function initializeState() {
    const state = initialState;

    const currentInstance = localStorage.getItem(Constants.CURRENT_INSTANCE);
    if (currentInstance) {
        state.currentInstance = JSON.parse(currentInstance);
    }

    return state;
}

const updateRegEntrySwap = (entryId, initialState) => {
    const newMap = {...initialState.playersPageEntryMap};
    const entry = {...newMap[entryId]};
    const newPlayers = [entry.players[1], entry.players[0]];
    entry.players = newPlayers;
    newMap[entry.id] = entry;
    return {
        ...initialState, initialState,
        playersPageEntryMap: newMap
    };
};

const updateRegEntryDelete = (entryId, newDeletedState, initialState) => {
    const newMap = {...initialState.playersPageEntryMap};
    const entry = {...newMap[entryId]};
    entry.deleted = newDeletedState;
    newMap[entry.id] = entry;
    return {
        ...initialState, initialState,
        playersPageEntryMap: newMap
    };
};

const updateRegEntryEdit = (entryId, newRegEntry, initialState) => {
    const newMap = {...initialState.playersPageEntryMap};
    const entry = {...newMap[entryId]};

    entry.players = newRegEntry.players;
    newMap[entry.id] = entry;
    return {
        ...initialState, initialState,
        playersPageEntryMap: newMap,
        regEntryUpdateStatus: actions.UPDATE_REGISTRATION_ENTRY_SUCCESS,
        regEntryUpdateError: null
    };
}


const parseLoginError = (err) => {
    let txt = err.message;
    if (err.response) {
        if (err.response.status === 401) {
            txt = 'Unable to log in - bad username or password';
        }
    }
    return txt;

}

function rootReducer(state = initializeState(), action) {
    switch (action.type) {
        case actions.DELETE_REGISTRATION_ENTRY_ERROR:
            return {
                ...state,
                deleteEntryError: action.err
            };
        case 'LOAD_INSTANCE_STARTED':
            return {
                ...state,
                loadInstanceStarted: true,
                loadInstanceRetrySec: 0,
                loadInstanceErrorCount: 0
            };
        case 'LOAD_INSTANCE_RETRY':
            return {
                ...state,
                loadInstanceRetrySec: action.retrySeconds,
                loadInstanceErrorCount: action.errorCount
            }
        case actions.INSTANCE_LOADED:
            const serializedInstance = JSON.stringify(action.instance)
            localStorage.setItem(Constants.CURRENT_INSTANCE, serializedInstance);
            return {
                ...state,
                currentInstance: action.instance,
                loadInstanceStarted: false,
                loadInstanceRetrySec: 0
            };
        case actions.LOGIN_STARTED:
            return {
                ...state,
                loginStatus: action.type,
                loginError: null,
                username: null,
                fullName: null
            };
        case actions.LOGIN_SUCCESS:
            return {
                ...state,
                currentToken: action.token,
                loginStatus: action.type,
                loginError: null,
                username: action.username,
                fullName: action.fullName
            };
        case actions.LOGIN_ERROR:
            const loginError = parseLoginError(action.err);
            return {
                ...state,
                loginStatus: action.type,
                loginError: loginError
            };
        case actions.LOGOUT:
            return {
                ...state,
                currentToken: null
            };
        case actions.EDIT_REGISTRATION_ENTRY:
            const newPlayers = action.regEntry ? action.regEntry.players.map((p) => {return {...p};}) : null;
            return {
                ...state,
                regEntryEdit: action.regEntry,
                regEntryEditPlayers: newPlayers
            };
        case actions.EDIT_REGISTRATION_ENTRY_PLAYERS:
            return {
                ...state,
                regEntryEditPlayers: action.players
            };
        case actions.UPDATE_REGISTRATION_ENTRY_STARTED:
            return {
                ...state,
                regEntryUpdateStatus: action.type,
                regEntryUpdateError: null
            };
        case actions.UPDATE_REGISTRATION_ENTRY_RESET:
            return {
                ...state,
                regEntryUpdateStatus: null,
                regEntryUpdateError: null
            };
        case actions.UPDATE_REGISTRATION_ENTRY_SUCCESS:
            return updateRegEntryEdit(action.entry.id, action.entry, state);
        case actions.UPDATE_REGISTRATION_ENTRY_ERROR:
            return {
                ...state,
                regEntryUpdateStatus: action.type,
                regEntryUpdateError: action.error
            };
        case actions.DELETE_REGISTRATION_ENTRY_SUCCESS:
            return updateRegEntryDelete(action.entryId, action.newDeletedState, state);
            // const newMap = {...state.playersPageEntryMap};
            // const entry = {...newMap[action.entryId]};
            // const newPlayers = [entry.players[1], entry.players[0]];
            // entry.players = newPlayers;
            // newMap[entry.id] = entry;
            // return {
            //     ...state,
            //     playersPageEntryMap: newMap
            // };
        case actions.SWAP_PLAYERS_SUCCESS:
            return updateRegEntrySwap(action.entryId, state);
            // const newMap = {...state.playersPageEntryMap};
            // const entry = {...newMap[action.entryId]};
            // const newPlayers = [entry.players[1], entry.players[0]];
            // entry.players = newPlayers;
            // newMap[entry.id] = entry;
            // return {
            //     ...state,
            //     playersPageEntryMap: newMap
            // };
        case actions.ENTRIES_LOAD_SUCCESS:
            const entryMap = {};
            action.data.forEach((n) => entryMap[n.id] = n);
            return {
                ...state,
                currentEntries: action.data,
                filteredEntries: action.data,
                playersPageEntryMap: entryMap,
                playersPagePage: 0
            };

        case actions.ENTRIES_LOAD_ERROR:
            return {
                ...state,
                currentEntries: [],
                filteredEntries: []
            };
        case actions.SET_PLAYERS_PAGE_SORT:
            const newState = {...state};
            if (action.orderBy) {
                newState.playersPageOrderBy = action.orderBy;
            }
            if (action.order) {
                newState.playersPageOrder = action.order;
            }
            if (action.rowsPerPage) {
                newState.playersPageRowsPerPage = action.rowsPerPage;
            }
            if (typeof(action.page) === 'number') {
                newState.playersPagePage = action.page;
            }
            return newState;
        default:
            return state;
    }
}

export default rootReducer;